import {generalConfig} from "../../util/config";
import {labels} from "../../util/constants";
import moment from "moment/moment";

export const getDownloadHeader = () => {
    let headers = [
        { label: labels.registration, key: 'id_user' },
        { label: labels.name, key: 'user_name' },
        { label: labels.userEmail, key: 'user_email' },
        { label: labels.userCResp, key: 'user_cresp' },
        { label: labels.profile, key: 'profile_type' },
        { label: labels.market, key: 'market' },
        { label: labels.plateVehicle, key: 'license_plate' },
        { label: labels.model, key: 'model_car' },
        { label: labels.year, key: 'model_year' },
        { label: labels.fuelType, key: 'fuel_type' },
        { label: labels.groups, key: 'group_name' },
        { label: labels.claimedItem, key: 'claimed_name' },
        { label: labels.anomaly, key: 'anomaly_name' },
        { label: labels.originalDescription, key: 'original_description' },
        { label: labels.revisionDescription, key: 'revision_description' },
        { label: labels.creationDate, key: 'creation_date' },
        { label: labels.status, key: 'status_label' },
        { label: labels.statusDate, key: 'update_date' }
    ];

    return headers;
};

export const getDownloadData = (experiencesData, componentGroupData) => {
    let data = [];
    if (experiencesData.length > 0) {
        experiencesData.map((experience) => {
            let item = {};
            item.id_user = experience.id_user;
            item.user_name = experience.user_name;
            item.user_email = experience.user_email;
            item.user_cresp = experience.user_cresp;
            item.profile_type = experience.profile_type;
            item.market = experience.market;
            item.license_plate = experience.license_plate;
            item.model_car = experience.model_car;
            item.model_year = experience.model_year;
            item.fuel_type = experience.fuel_type;
            item.group_name = getGroupName(experience.id_group, componentGroupData);
            item.claimed_name = experience.claimed_name_pt;
            item.anomaly_name = experience.anomaly_name_pt;
            item.original_description = experience.original_description;
            item.revision_description = experience.revision_description;
            item.creation_date = moment(experience.creation_date).format(generalConfig.dateFormat);
            item.status_label = experience.status_label;
            item.update_date = moment(experience.update_date).format(generalConfig.dateFormat);

            data.push(item);
        });
    }

    return data;
};

export const getGroupName = (id_group, groupList) => {
    let groupName = '';
    if(id_group && id_group !== '' && groupList && groupList.length > 0) {
        groupList.map((group) => {
            if (group.id_group === id_group) {
                groupName = group.group_name_pt;
            }
        });
    }

    return groupName;
};



// WEBPACK FOOTER //
// ./src/containers/experiences/experiencesFileDownload.js